import { Box } from "@mui/material";
import SideBar from "../../components/sidebar";
import MainWrapper from "../../components/helpers/MainWrapper";
import LifeStyle1 from "../../images/life-style-1.jpg";
import Life1 from "../../images/life1.WEBP";
import Life2 from "../../images/life2.WEBP";
import Life3 from "../../images/life3.WEBP";
import Life4 from "../../images/life4.WEBP";
import Life5 from "../../images/life5.WEBP";
import Life6 from "../../images/life7.WEBP";
import Life7 from "../../images/life8.WEBP";
import LifeStyle2 from "../../images/life-style-2.jpg";
import { Swiper, SwiperSlide } from "swiper/react";

const slideShowData = [
  {
    id: 1,
    photo: LifeStyle1,
  },
  {
    id: 2,
    photo: Life1,
  },
  {
    id: 3,
    photo: Life2,
  },
  {
    id: 4,
    photo: Life3,
  },
  {
    id: 5,
    photo: Life4,
  },
  {
    id: 6,
    photo: Life5,
  },
  {
    id: 7,
    photo: Life6,
  },
  {
    id: 8,
    photo: Life7,
  },
];

const ProductEffect3 = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <SideBar />
      <MainWrapper top={{ xs: "8em", lg: "12rem", xl: "20rem" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Box
            sx={{
              position: { xs: "absolute", md: "static" },
              top: "100%",
              width: { xs: "80%", md: "50%", xl: "49.1%" },
              marginLeft: { xs: "3rem", md: "initial" },
            }}
          >
            <Swiper direction="horizontal" slidesPerView={1} spaceBetween={10}>
              {slideShowData.map((slide) => (
                <SwiperSlide key={slide.id}>
                  <Box
                    sx={{
                      width: { xs: "340px", sm: "470px", md: "auto" },
                      height: { xs: "250px", sm: "300px", md: "auto" },
                      objectFit: "cover",
                    }}
                  >
                    <img width="100%" height="100%" src={slide.photo} alt="" />
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
          <Box
            sx={{
              width: { xs: "80%", md: "50%" },
              marginLeft: { xs: "3rem", md: "initial" },
            }}
          >
            <img
              width="100%"
              height="100%"
              src={LifeStyle2}
              alt="life style 2"
            />
          </Box>
        </Box>
      </MainWrapper>
    </Box>
  );
};

export default ProductEffect3;
